import PageError from 'components/PageError';
import PageLoading from 'components/PageLoading';
import { PageWithApiItems } from 'components/PageWithApiItems';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getConfigData, PromoCodeResult } from 'api';
import { resetAll } from 'store/answers/answersSlice';
import { unsubscribeLocalStorage } from 'store/store';
import { OldCOnfigurationWarning } from 'components/OldConfigurationWarning';
import { useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { importSavedConfig } from 'features/utils/importSavedConfig';
import PageSummary from './PageSummary';

const PageEstimate = () => {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isOldConfiguration, setIsOldConfiguration] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [promoCodeDetails, setPromoCodeDetails] = useState<
    PromoCodeResult | undefined
  >();
  const toast = useToast();
  const { t } = useTranslation();

  // fetch configuration datas
  useEffect(() => {
    if (search) {
      let configId = new URLSearchParams(search)?.get('id');
      if (configId) {
        configId = configId.toLowerCase();
        setIsLoading(true);
        getConfigData(configId)
          .then((result) => {
            unsubscribeLocalStorage(); // be sure now that we are in "preview" mode that we wont save anything to localstorage
            const savedData = { ...result.data };
            // remove non-answers from database save
            console.log('Saved Config Datas:', savedData);
            if (savedData.promoCodeDetails) {
              // TODO: save promocode details in redux.. and retreive it inside page summary
              setPromoCodeDetails(savedData.promoCodeDetails);
              delete savedData.promoCodeDetails;
            }

            const importResult = importSavedConfig(configId, result);
            const { answers } = importResult;

            // case we need to display a toast
            if (importResult.toast) {
              toast({
                title: t('estimate.incorrectConfig.title'),
                description: `${t('estimate.incorrectConfig.description')}`,
                status: 'info',
                position: 'top',
                duration: 6000,
                isClosable: true,
              });
            }

            // case we need to redirect
            // => previous offers conditions, we redirect to home and show a old configuraiton warning
            if (importResult.redirect) {
              console.warn(`old configuration detected: ${configId}`);
              setIsOldConfiguration(true);
              setIsLoading(false);
            }
            // case everything is right, we can continue
            else {
              dispatch(resetAll(answers));
              setIsLoading(false);
            }
          })
          .catch((__error) => {
            setErrorMessage(t('estimate.load.error', { id: configId }));
          });
      }
    } else {
      setErrorMessage('No configuration ID');
    }
  }, [search, dispatch, setIsOldConfiguration, t, toast]);

  if (errorMessage) {
    return <PageError error={errorMessage} />;
  }

  if (isLoading) {
    return <PageLoading />;
  }

  if (isOldConfiguration) {
    return <OldCOnfigurationWarning />;
  }

  return (
    <PageWithApiItems>
      <PageSummary preview savedPromoCodeDetails={promoCodeDetails} />
    </PageWithApiItems>
  );
};

export default PageEstimate;
